var _rect, _mask, _path, _tspan, _tspan2, _tspan3, _tspan4, _tspan5, _tspan6, _tspan7, _mask2, _path2, _tspan8, _tspan9, _tspan10, _tspan11, _tspan12, _tspan13, _tspan14, _tspan15, _mask3, _path3, _tspan16, _tspan17, _tspan18, _tspan19, _tspan20, _tspan21, _tspan22, _tspan23, _mask4, _path4, _tspan24, _tspan25, _tspan26, _tspan27, _tspan28, _tspan29, _tspan30, _tspan31, _mask5, _path5, _path6, _tspan32, _tspan33, _tspan34, _tspan35, _tspan36, _tspan37, _tspan38, _tspan39, _mask6, _path7, _path8, _tspan40, _tspan41, _tspan42, _tspan43, _tspan44, _tspan45, _tspan46, _tspan47, _rect2, _rect3, _tspan48, _rect4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStandings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 411,
    height: 336,
    viewBox: "0 0 411 336",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1002_45392)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1002_45392)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 10,
    width: 370,
    height: 296,
    rx: 10,
    className: "component-background"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_1002_45392",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 16C20.5 12.6863 23.1863 10 26.5 10H384.5C387.814 10 390.5 12.6863 390.5 16V65H20.5V16Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 10H390.5H20.5ZM390.5 66H20.5V64H390.5V66ZM20.5 65V10V65ZM390.5 10V65V10Z",
    className: "component-divider",
    fillOpacity: 0.15,
    mask: "url(#path-3-inside-1_1002_45392)"
  })), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 18,
    fontWeight: "bold",
    letterSpacing: "0px"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 30.5,
    y: 42.71
  }, "TABELLEN"))), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 182.847,
    y: 44.14
  }, "S"))), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 207.405,
    y: 44.14
  }, "V"))), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 235.405,
    y: 44.14
  }, "O"))), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 263.405,
    y: 44.14
  }, "F"))), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: 314.36,
    y: 44.14
  }, "+/-"))), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    x: 365.637,
    y: 44.14
  }, "P"))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-12-inside-2_1002_45392",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 65H390.5V99H20.5V65Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M390.5 98H20.5V100H390.5V98Z",
    className: "component-foreground-id",
    mask: "url(#path-12-inside-2_1002_45392)"
  })), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    x: 51.5,
    y: 86.098
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 13,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    x: 77.5,
    y: 86.4395
  }, "Allsvenskan"))), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    x: 179.5,
    y: 86.098
  }, "20"))), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan11 || (_tspan11 = /*#__PURE__*/React.createElement("tspan", {
    x: 207.5,
    y: 86.098
  }, "13"))), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan12 || (_tspan12 = /*#__PURE__*/React.createElement("tspan", {
    x: 235.5,
    y: 86.098
  }, "5"))), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan13 || (_tspan13 = /*#__PURE__*/React.createElement("tspan", {
    x: 263.5,
    y: 86.098
  }, "2"))), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan14 || (_tspan14 = /*#__PURE__*/React.createElement("tspan", {
    x: 309.773,
    y: 86.098
  }, "42-16"))), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan15 || (_tspan15 = /*#__PURE__*/React.createElement("tspan", {
    x: 366.461,
    y: 86.098
  }, "44"))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-22-inside-3_1002_45392",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 101H390.5V135H20.5V101Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M390.5 134H20.5V136H390.5V134Z",
    className: "component-foreground-id",
    mask: "url(#path-22-inside-3_1002_45392)"
  })), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan16 || (_tspan16 = /*#__PURE__*/React.createElement("tspan", {
    x: 51.5,
    y: 122.098
  }, "2"))), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 13,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan17 || (_tspan17 = /*#__PURE__*/React.createElement("tspan", {
    x: 77.5,
    y: 122.439
  }, "Lag 2"))), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan18 || (_tspan18 = /*#__PURE__*/React.createElement("tspan", {
    x: 179.5,
    y: 122.098
  }, "20"))), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan19 || (_tspan19 = /*#__PURE__*/React.createElement("tspan", {
    x: 207.5,
    y: 122.098
  }, "13"))), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan20 || (_tspan20 = /*#__PURE__*/React.createElement("tspan", {
    x: 235.5,
    y: 122.098
  }, "5"))), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan21 || (_tspan21 = /*#__PURE__*/React.createElement("tspan", {
    x: 263.5,
    y: 122.098
  }, "2"))), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan22 || (_tspan22 = /*#__PURE__*/React.createElement("tspan", {
    x: 309.773,
    y: 122.098
  }, "42-16"))), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan23 || (_tspan23 = /*#__PURE__*/React.createElement("tspan", {
    x: 369.238,
    y: 122.098
  }, "41"))), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-32-outside-4_1002_45392",
    maskUnits: "userSpaceOnUse",
    x: 20.5,
    y: 137,
    width: 370,
    height: 36,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 20.5,
    y: 137,
    width: 370,
    height: 36
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 137H390.5V171H20.5V137Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M390.5 169H20.5V173H390.5V169Z",
    className: "component-foreground-id",
    mask: "url(#path-32-outside-4_1002_45392)"
  })), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan24 || (_tspan24 = /*#__PURE__*/React.createElement("tspan", {
    x: 51.5,
    y: 158.098
  }, "3"))), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 13,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan25 || (_tspan25 = /*#__PURE__*/React.createElement("tspan", {
    x: 77.5,
    y: 158.439
  }, "Lag 3"))), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan26 || (_tspan26 = /*#__PURE__*/React.createElement("tspan", {
    x: 179.5,
    y: 158.098
  }, "20"))), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan27 || (_tspan27 = /*#__PURE__*/React.createElement("tspan", {
    x: 207.5,
    y: 158.098
  }, "13"))), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan28 || (_tspan28 = /*#__PURE__*/React.createElement("tspan", {
    x: 235.5,
    y: 158.098
  }, "5"))), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan29 || (_tspan29 = /*#__PURE__*/React.createElement("tspan", {
    x: 263.5,
    y: 158.098
  }, "2"))), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan30 || (_tspan30 = /*#__PURE__*/React.createElement("tspan", {
    x: 309.773,
    y: 158.098
  }, "42-16"))), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan31 || (_tspan31 = /*#__PURE__*/React.createElement("tspan", {
    x: 365.98,
    y: 158.098
  }, "40"))), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-42-inside-5_1002_45392",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 173H390.5V207H20.5V173Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M390.5 206H20.5V208H390.5V206Z",
    className: "component-divider",
    fillOpacity: 0.15,
    mask: "url(#path-42-inside-5_1002_45392)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5157 189.144L36.0078 184L41.5 189.144L40.2133 190.355L36.918 187.277L36.918 196H35.082L35.082 187.263L31.7867 190.341L30.5 189.13L30.5157 189.144Z",
    fill: "#69C159"
  })), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan32 || (_tspan32 = /*#__PURE__*/React.createElement("tspan", {
    x: 51.5,
    y: 194.098
  }, "4"))), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 13,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan33 || (_tspan33 = /*#__PURE__*/React.createElement("tspan", {
    x: 77.5,
    y: 194.439
  }, "Lag 4"))), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan34 || (_tspan34 = /*#__PURE__*/React.createElement("tspan", {
    x: 179.5,
    y: 194.098
  }, "20"))), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan35 || (_tspan35 = /*#__PURE__*/React.createElement("tspan", {
    x: 207.5,
    y: 194.098
  }, "13"))), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan36 || (_tspan36 = /*#__PURE__*/React.createElement("tspan", {
    x: 235.5,
    y: 194.098
  }, "5"))), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan37 || (_tspan37 = /*#__PURE__*/React.createElement("tspan", {
    x: 263.5,
    y: 194.098
  }, "2"))), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan38 || (_tspan38 = /*#__PURE__*/React.createElement("tspan", {
    x: 309.773,
    y: 194.098
  }, "42-16"))), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan39 || (_tspan39 = /*#__PURE__*/React.createElement("tspan", {
    x: 367.328,
    y: 194.098
  }, "36"))), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-53-inside-6_1002_45392",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 209H390.5V243H20.5V209Z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M390.5 242H20.5V244H390.5V242Z",
    className: "component-divider",
    fillOpacity: 0.15,
    mask: "url(#path-53-inside-6_1002_45392)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4843 226.856L35.9922 232L30.5 226.856L31.7867 225.645L35.082 228.723L35.082 220L36.918 220L36.918 228.737L40.2133 225.659L41.5 226.87L41.4843 226.856Z",
    fill: "#CF021A"
  })), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan40 || (_tspan40 = /*#__PURE__*/React.createElement("tspan", {
    x: 51.5,
    y: 230.098
  }, "5"))), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 13,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan41 || (_tspan41 = /*#__PURE__*/React.createElement("tspan", {
    x: 77.5,
    y: 230.439
  }, "Lag 5"))), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan42 || (_tspan42 = /*#__PURE__*/React.createElement("tspan", {
    x: 179.5,
    y: 230.098
  }, "20"))), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan43 || (_tspan43 = /*#__PURE__*/React.createElement("tspan", {
    x: 207.5,
    y: 230.098
  }, "13"))), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan44 || (_tspan44 = /*#__PURE__*/React.createElement("tspan", {
    x: 235.5,
    y: 230.098
  }, "5"))), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan45 || (_tspan45 = /*#__PURE__*/React.createElement("tspan", {
    x: 263.5,
    y: 230.098
  }, "2"))), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan46 || (_tspan46 = /*#__PURE__*/React.createElement("tspan", {
    x: 309.773,
    y: 230.098
  }, "42-16"))), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan47 || (_tspan47 = /*#__PURE__*/React.createElement("tspan", {
    x: 366.883,
    y: 230.098
  }, "34"))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 254,
    width: 350,
    height: 42,
    rx: 6,
    className: "button-background"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 254.5,
    width: 349,
    height: 41,
    rx: 5.5,
    stroke: "white",
    strokeOpacity: 0.15
  })), /*#__PURE__*/React.createElement("text", {
    className: "button-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0px"
  }, _tspan48 || (_tspan48 = /*#__PURE__*/React.createElement("tspan", {
    x: 145.266,
    y: 279.14
  }, "VISA HELA TABELLEN")))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 10.5,
    width: 369,
    height: 295,
    rx: 9.5,
    className: "component-border",
    strokeOpacity: 0.15
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1002_45392",
    x: 0.5,
    y: 0,
    width: 410,
    height: 336,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1002_45392"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1002_45392",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1002_45392"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 10,
    width: 370,
    height: 296,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandings);
export default __webpack_public_path__ + "static/media/standings.c18ad636567299945ee77e62a3cc8db6.svg";
export { ForwardRef as ReactComponent };